export default __webpack_public_path__ + "static/media/css3.98daf49e.svg";